const user = {
  state: {
    lang: ''
  },

  mutations: {
    SET_STORAGE: (state, value) => {
      state.lang = value
      window.localStorage.setItem('lang', value);
    },
    GET_STORAGE: (state) => {
      state.lang = window.localStorage.getItem('lang');
    },
    REMOVE_STORAGE: (state) => {
      window.localStorage.removeItem('lang');
      state.lang = ''
    }
  },

  actions: {
    
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/lang.js